import apiClient from '../apiClient';
import { normalizeBusiness } from '../transformers';

export const fetchBusinesses = async () => {
  const response = await apiClient.get('/businesses');
  const data = Array.isArray(response?.data) ? response.data : [];
  return data.map(normalizeBusiness).filter(Boolean);
};

export default {
  fetchBusinesses,
};
